import React from "react"
import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

const InputOuter = styled(Flex)`
  width: 100%;
`

const InputInner = styled.div`
  width: 100%;
`

export const InputHolder: React.FC = (props) => {
  return (
    <InputOuter justifyContent="space-between">
      <InputInner>{props.children}</InputInner>
    </InputOuter>
  )
}
